import { useAuth } from '@/composables/useAuth'

export default defineNuxtRouteMiddleware((to, from) => {
	const { cookie } = useAuth()

	if ((to.meta.layout === 'dashboard' || to.meta.layout === 'more-view') && !cookie.value) {
		const routeQuery = from.query || to.query

		return navigateTo(
			{
				path: '/login',
				query: {
					...routeQuery,
					return_url: from.path
				}
			},
			{
				replace: true
			}
		)
	}
})
